interface DeviceAdminPageData {
  orgId: string | number;
}

interface DeviceAdminUpdateData {
  id?: string | number;
  org?: string | number;
  orgId?: string | number;
  type?: string;
  [key: string]: string | number | undefined;
}

interface DeviceAdminCreateData {
  orgId?: string | number;
}

interface DeviceAdminRoute {
  page: string;
  updatePage: string;
  createPage: string;
  getPage: (data: DeviceAdminPageData) => string;
  getUpdatePage: (data: DeviceAdminUpdateData) => string;
  getCreatePage: (data?: DeviceAdminCreateData) => string;
}

const _deviceAdminRoute: DeviceAdminRoute = {
  page: "/trackers_admin",
  updatePage: "/trackers_admin_update",
  createPage: "",
  getPage: (data) => {
    return `/trackers_admin?org=${data.orgId}`;
  },
  getUpdatePage: (data) => {
    data.org = data.org || data.orgId;

    const queryString = new URLSearchParams(
      data as Record<string, string>
    ).toString();
    return `/trackers_admin_update?${queryString}`;
  },
  getCreatePage: (data) => {
    if (data?.orgId) return `/trackers_admin_update?org=${data.orgId}`;
    return `/trackers_admin_update?`;
  },
};

export default _deviceAdminRoute;
